import { render, staticRenderFns } from "./PackagesGroupedTable.vue?vue&type=template&id=978c3c2a"
import script from "./PackagesGroupedTable.vue?vue&type=script&lang=js"
export * from "./PackagesGroupedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports